import { render, staticRenderFns } from "./panel-user.vue?vue&type=template&id=898dce22&scoped=true"
import script from "./panel-user.vue?vue&type=script&lang=js"
export * from "./panel-user.vue?vue&type=script&lang=js"
import style0 from "./panel-user.vue?vue&type=style&index=0&id=898dce22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898dce22",
  null
  
)

export default component.exports